import { useState, useEffect, useCallback } from 'react';
import { useSession } from 'next-auth/react';
import { toast } from 'sonner';
import { getAllUserOrders } from '@/services/user/orders';

const useAutoPaginateOrders = ({
  pageSize = 10,
  page: defaultPage = 1,
  dateFilter = 'last_3_week',
  mage,
}) => {
  const { data: session } = useSession();
  const userId = session?.user?.id;
  const [orders, setOrders] = useState({ items: [] });
  const [loading, setLoading] = useState(null);
  const [page, setPage] = useState(defaultPage);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  const loadOrders = useCallback(
    async (initialLoad = false) => {
      if (loading || !userId) return;

      setLoading(true);

      // const formattedDateFilter = getDateFilter(dateFilter);
      try {
        // const { handshake, mage } = getCookies();
        const { data } = await getAllUserOrders({
          mage,
          customer_id: userId,
          pageSize,
          page,
          date_filter: dateFilter,
        });
        const res = data.data.at(0);
        if (initialLoad) {
          setOrders({ items: res.items });
        } else {
          setOrders((prevOrders) => ({
            ...prevOrders,
            items: [...prevOrders.items, ...res.items],
          }));
        }

        const totalItems = res.total_count || 0;
        const totalPages = Math.ceil(totalItems / pageSize);

        setAllDataLoaded(
          res.items.length === 0 || page >= totalPages || totalItems === 0
        );
      } catch (error) {
        console.error('Error loading orders:', error);
        toast.error('An error occurred while loading orders data');
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userId, loading, page, pageSize, dateFilter]
  );

  useEffect(() => {
    if (dateFilter) {
      setAllDataLoaded(false);
      setPage(1);
    }

    userId && loadOrders(page === 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, dateFilter, userId]);

  const loadMoreOrders = () => {
    if (!allDataLoaded) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  return {
    orders,
    loading,
    loadMoreOrders,
    allDataLoaded,
  };
};

export default useAutoPaginateOrders;
